import React from 'react';
import { toast } from 'sonner';
export function Subscribe() {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success('תודה! המנוי שלך אושר.', {
      style: {
        background: 'var(--ink)',
        color: 'var(--paper)',
        border: 'none',
        fontFamily: 'Heebo, sans-serif'
      }
    });
  };
  return <section className="px-4 md:px-8 py-24 md:py-32 border-b border-ink/20" data-id="element-158">
      <div className="max-w-3xl mx-auto" data-id="element-159">
        <div className="border-4 border-ink p-8 md:p-16 text-center relative" data-id="element-160">
          {/* Corner accents */}
          <div className="absolute top-0 right-0 w-4 h-4 border-b border-l border-paper bg-ink" data-id="element-161" />
          <div className="absolute top-0 left-0 w-4 h-4 border-b border-r border-paper bg-ink" data-id="element-162" />
          <div className="absolute bottom-0 right-0 w-4 h-4 border-t border-l border-paper bg-ink" data-id="element-163" />
          <div className="absolute bottom-0 left-0 w-4 h-4 border-t border-r border-paper bg-ink" data-id="element-164" />

          <h2 className="font-serif text-4xl md:text-6xl font-black text-ink mb-4" data-id="element-165">
            הצטרפו לקריאה
          </h2>
          <p className="font-sans text-lg text-ink-soft mb-10 max-w-md mx-auto" data-id="element-166">
            קבלו את המאמרים, הראיונות והמחשבות הטובות ביותר שלנו, ישירות לתיבת
            הדואר שלכם. פעם בשבוע, בלי ספאם.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col md:flex-row gap-4 max-w-lg mx-auto" data-id="element-167">
            <input type="email" placeholder="כתובת דוא״ל" required className="flex-grow px-4 py-3 bg-transparent border-b-2 border-ink/30 focus:border-vermillion outline-none font-sans text-ink placeholder:text-ink/40 transition-colors text-right dir-rtl" data-id="element-168" />
            <button type="submit" className="px-8 py-3 bg-ink text-paper font-sans font-bold hover:bg-vermillion transition-colors whitespace-nowrap" data-id="element-169">
              הרשמה
            </button>
          </form>
        </div>
      </div>
    </section>;
}